module.exports = __webpack_public_path__ + "img/text.eda05b46.gif";